import { DEVICE_TYPE } from '../../config/devices';
import { IModalBase } from '../../modules/commonTypes';

export interface IDeviceModal {
  deviceType: string | undefined;
  open: boolean;
  onClose: IModalBase['onClose'];
  onSelectDevice: (device: string) => void;
}

export type TDevicesControlValues =
  | typeof DEVICE_TYPE.DOOR_STATION
  | typeof DEVICE_TYPE.HIPMO
  | typeof DEVICE_TYPE.THIRD_PARTY
  | typeof DEVICE_TYPE.AXIS_ANSWERING_UNIT
  | 'AXIS_DEVICE'
  | 'X2N';

export enum AddDeviceErrorType {
  INVALID_SECURITY_CODE = 'INVALID_SECURITY_CODE',
}
